import { useNavigate } from 'react-router-dom';

import { z } from 'zod';

import { useAuth } from '../../../../shared/hooks';
import { deserializer } from '../../../../shared/utils';
import { WORKFLOW } from '../../../shared/constants';
import { login as apiLogin } from '../services/sessionService';
import useAuthForm from './useAuthForm';

const DEFAULT_VALUES = {
  email: '',
  password: '',
};

const formSchema = z.object({
  email: z.string().email('Invalid email address.'),
  password: z.string().min(1, 'Password is required.'),
});

const useLoginForm = () => {
  const { startSession } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (formData) => {
    const response = await apiLogin(formData);
    const jwtToken = response.headers.authorization;
    const user = await deserializer.deserialize(response.data);

    startSession({ jwtToken, entity: user });
    navigate(WORKFLOW);
  };

  const authForm = useAuthForm({
    defaultValues: DEFAULT_VALUES,
    onSubmit: handleSubmit,
    schema: formSchema,
  });

  return {
    ...authForm,
    isUserLocked: authForm.error?.code === 'locked',
  };
};

export default useLoginForm;
